<template>
  <l-fixed-window>
    <v-tabs grow slot="fixed-top" v-model="tabs">
      <v-tab href="#common">通用配置</v-tab>
    </v-tabs>
    <div>
      <v-tabs-items v-model="tabs">
        <v-tab-item :value="'common'">
          <common-Config :order-type-prop="'admin'" :status-prop="'readonly'" :owner-type-prop="'common'"></common-Config>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </l-fixed-window>
</template>

<script>
import commonConfig from '../Common/commonConfig'
export default {
  name: 'PersonGroupReservationConfig',
  components: {
    commonConfig
  },
  data () {
    return {
      tabs: null
    }
  }
}
</script>

<style scoped>

</style>
